// extracted by mini-css-extract-plugin
export default {"label":"SectionLabel_label__6Ggv3","tags":"SectionLabel_tags__K1TC9"};